import React, { useEffect, useState, useRef } from "react";
import Input from "../../components/FormComponents/Input/Input";
import Select from "../../components/FormComponents/Select/Select";
import Spinner from "react-bootstrap/Spinner";
import _, { set } from "lodash";
import { useDispatch } from "react-redux";
import { Link, useHistory, withRouter } from "react-router-dom";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import SelectDate from "../../components/FormComponents/SelectDate/SelectDate";
import { usStates } from "../../utils/usStates";
import moment from "moment";

const PickCustomer = (props) => {
	const [newCustomer, setNewCustomer] = useState(false);
	const [selected, setSelected] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingCard, setLoadingCard] = useState(false);
	const [options, setOptions] = useState([]);
	const [customer, setCustomer] = useState({});

	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [birthDate, setBirthDate] = useState(null);
	const [email, setEmail] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [street, setStreet] = useState("");
	const [secondStreet, setSecondStreet] = useState("");
	const [city, setCity] = useState("");
	const [state, setState] = useState("");
	const [zipCode, setZipCode] = useState("");
	const [municipality, setMunicipality] = useState("");
	const [enterprise, setEnterprise] = useState("");
	const [companyName, setCompanyName] = useState("");

	const firstNameRef = useRef();
	const lastNameRef = useRef();
	const emailRef = useRef();
	const streetRef = useRef();
	const cityRef = useRef();
	const stateRef = useRef();
	const zipCodeRef = useRef();
	const municipalityRef = useRef();
	const birthDateRef = useRef();
	const companyNameRef = useRef();

	const { customerEmail } = props;

	const dispatch = useDispatch();
	let history = useHistory();

	const usStateOptions = usStates.map((state) => (
		<option value={state.value} key={state.value}>
			{state.name}
		</option>
	));

	var Typeahead = require("react-bootstrap-typeahead").Typeahead;

	useEffect(() => {
		if (customerEmail) {
			searchCustomers(customerEmail);
			setSelected(true);
		}
	}, [customerEmail]);

	useEffect(() => {
		if (customerEmail && options.length > 0) {
			setSelected([options[0]]);
		}
	}, [options]);

	function getMeta(metaName) {
		const metas = document.getElementsByTagName("meta");

		for (let i = 0; i < metas.length; i++) {
			if (metas[i].getAttribute("name") === metaName) {
				return metas[i].getAttribute("content");
			}
		}

		return "";
	}

	function searchCustomers(search) {
		setLoading(true);
		const headers = new Headers({
			"X-CSRF-Token": getMeta("csrf-token"),
			"X-Requested-With": XMLHttpRequest,
			Accept: "application/json",
		});
		fetch(
			`/admin/customers?order=first_name_asc&q%5Bgroupings%5D%5B0%5D%5Bm%5D=or&q%5Bgroupings%5D%5B0%5D%5Bfirst_name_contains%5D=${search}&q%5Bgroupings%5D%5B0%5D%5Blast_name_contains%5D=${search}&q%5Bgroupings%5D%5B0%5D%5Buser_email_contains%5D=${search}&q%5Bcombinator%5D=and`,
			{ method: "GET", headers }
		)
			.then((response) => response.json())
			.then((data) => {
				const options = data.map((customer) => ({
					value: customer.id,
					label: customer.first_name + " " + customer.last_name,
					name: customer.first_name,
					last_name: customer.last_name,
					address: customer.address1,
					city: customer.city,
					zip: customer.zip,
				}));

				setOptions(options);
				setIsSearching(false);
				setLoading(false);
			});
	}

	const [searchTerm, setSearchTerm] = useState("");
	// API search results
	const [results, setResults] = useState(null);
	// Searching status (whether there is pending API request)
	const [isSearching, setIsSearching] = useState(false);

	const debounceSearch = useRef(
		_.debounce((searchTerm) => {
			setSelected(false);
			searchCustomers(searchTerm);
		}, 1000)
	);

	useEffect(
		() => {
			if (searchTerm) {
				setIsSearching(true);
				debounceSearch.current(searchTerm);
			} else {
				setResults(null);
			}
		},
		[searchTerm] // Only call effect if debounced search term changes
	);

	useEffect(
		() => {
			if (selected && selected.length > 0) {
				selected.map((select) => {
					createQuote(select.value);
				});
			}
		},
		[selected] // Only call effect if debounced search term changes
	);

	const createQuote = (id) => {
		setLoadingCard(true);
		const headers = new Headers({
			"X-CSRF-Token": getMeta("csrf-token"),
			"X-Requested-With": XMLHttpRequest,
			Accept: "application/json",
			"Content-Type": "application/json",
		});

		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ customer_id: id }),
		};
		fetch(`/api/v2/quotes`, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				setLoadingCard(false);
				setResults(data.quote);
			});
	};

	const createCustomer = (e) => {
		e.preventDefault();
		if (!checkErrorsForm()) {
			const headers = new Headers({
				"X-CSRF-Token": getMeta("csrf-token"),
				"X-Requested-With": XMLHttpRequest,
				Accept: "application/json",
				"Content-Type": "application/json",
			});

			const requestOptions = {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					customer: {
						company_name: companyName,
						is_enterprise: enterprise,
						first_name: firstName,
						last_name: lastName,
						address1: street,
						address2: secondStreet,
						city: city,
						state: state,
						zip_code: zipCode,
						municipality: municipality,
						email_address: email,
						date_of_birth: birthDate,
					},
				}),
			};
			fetch(`/api/v2/customers`, requestOptions)
				.then((response) => response.json())
				.then((data) => {
					createQuote(data.customer.id);
					setNewCustomer(false);
				});
		}
	};

	const filterBy = () => true;

	const viewPolicy = () => {
		dispatch({
			type: "SET_INITIAL_QUOTE_DATA",
			payload: results,
		});
		dispatch({
			type: "SET_RENEWAL_ID",
			payload: _.get(results, "quote_hash_id", ""),
		});
		history.push(`/admin/quote-builder/build`);
	};

	const checkErrorsForm = () => {
		let errors = false;
		let municipalityError = false;
		let relationError = false;

		const firstNameError = firstNameRef.current.validateInput();
		const lastNameError = lastNameRef.current.validateInput();
		const emailError = emailRef.current.validateInput();
		const streetError = streetRef.current.validateInput();
		const cityError = cityRef.current.validateInput();
		const zipCodeError = zipCodeRef.current.validateInput();
		const birthDateError = birthDateRef.current.validateInput();

		const stateError = stateRef.current.validateSelect();

		if (state === "KY") {
			municipalityError = municipalityRef.current.validateSelect();
		}

		if (
			firstNameError ||
			lastNameError ||
			emailError ||
			streetError ||
			cityError ||
			zipCodeError ||
			stateError ||
			birthDateError
		) {
			errors = true;
		} else {
			if (state === "KY") {
				if (municipalityError) {
					errors = true;
				}
			}
		}
		return errors;
	};

	return (
		<div className="pickcustomer general d-flex justify-content-center">
			<div className="otcontainer1 nopadding col otmb-5">
				<div className="col d-inline-block">
					<h1 className="otmt-2 otmb-4" style={{ color: "#00778a" }}>
						Quote Builder
					</h1>
					<h2 className="mb-0">Pick a customer</h2>
					<div className="col-md-7 pl-0 pr-0 d-md-flex">
						<div className="col-12 pl-0">
							<AsyncTypeahead
								filterBy={filterBy}
								id="async-example"
								labelKey="label"
								minLength={3}
								defaultInputValue={customerEmail ? customerEmail : ""}
								onChange={(selected) => {
									setSelected(selected);
								}}
								onSearch={searchCustomers}
								options={options}
								placeholder="Search"
								renderMenuItemChildren={(option, props) => (
									<div>
										<p>{option.label}</p>
									</div>
								)}
							/>
						</div>

						{loading && (
							<div className="align-items-center col d-flex ml-3 ml-md-0 mt-4 mt-md-0 pl-0">
								<Spinner animation="border" variant="primary" />
							</div>
						)}
					</div>
				</div>
				{loadingCard && (
					<div className="d-flex justify-content-center otmt-4">
						<Spinner animation="border" variant="primary" size="lg" />
					</div>
				)}
				{results && (
					<div className="col-12 d-flex">
						<div
							className={`mb-3 otmt-1 col ${selected ? "card-active" : "card"}`}
						>
							<div className="card-body d-flex otmt-1">
								<div className="col pl-0">
									<div className="d-flex">
										<div className="">
											<h2 className="circle pt-3 pt-md-2 text-center mb-0 text-uppercase">
												{_.get(results, "drivers[0].first_name", "").charAt(0)}
												{_.get(results, "drivers[0].last_name", "").charAt(0)}
											</h2>
										</div>
										<div className="col-11 mt-3 mt-md-0 pl-3">
											<span className="mb-0 mt-0 h3" id="name">
												{_.get(results, "drivers[0].first_name", "")}
											</span>
											<span className="ml-2 mb-0 mt-0 h3" id="last-name">
												{_.get(results, "drivers[0].last_name", "")}
											</span>
										</div>
									</div>
									<div className="col-12 d-lg-flex ml-5">
										<div className="col-lg-6">
											<div className="otmb-2">
												<p className="mb-1" id="e-mail">
													{_.get(results, "drivers[0].email", "")}
												</p>
												<p className="mb-1">phone number</p>
												<p className="mb-1" id="the-city">
													{_.get(results, "drivers[0].street", "")}
												</p>
												<p className="mb-1">
													<span id="the-city">
														{" "}
														{_.get(results, "drivers[0].city", "")}
													</span>
													,
													<span id="the-state">
														{" "}
														{_.get(results, "drivers[0].state", "")}
													</span>
													<span id="zip-code">
														{" "}
														{_.get(results, "drivers[0].zip", "")}
													</span>
												</p>
											</div>
										</div>
										<div className="col-lg-6">
											<div>
												<p style={{ textTransform: "uppercase" }}>Vehicles</p>
											</div>
											<div className="otmb-2">
												{results.cars && results.cars.length > 0
													? results.cars.map((car, i) => (
															<p className="mb-1" key={i}>
																{car.year} {car.make} {car.car_model}
															</p>
													  ))
													: "No Vehicles Recorded"}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}

				{!newCustomer && (
					<>
						{results && (
							<div className="col d-flex d-md-block justify-content-center otmt-1">
								<button className="btn btn-lg btn2" onClick={viewPolicy}>
									VIEW POLICY
								</button>
							</div>
						)}

						<div className="col d-flex d-md-block justify-content-center otmt-4 otmb-4">
							<p
								type="button"
								className="mb-0"
								style={{ color: "#01788A" }}
								onClick={() => {
									setNewCustomer(true);
								}}
							>
								<u>Add a new customer</u>
							</p>
						</div>
					</>
				)}

				{newCustomer && (
					<div id="driverform" className="col otmt-2 ">
						<div className="card mb-5">
							<div className="card-body col-11 mx-auto">
								<div className="d-flex justify-content-between otmb-2 otmt-1">
									<div className="">
										<h1 className="" style={{ color: "#00778a" }}>
											Add a new customer
										</h1>
									</div>
									<div className="">
										<i
											className="bi bi-x "
											onClick={() => {
												setNewCustomer(false);
											}}
										></i>
									</div>
								</div>
								<form onSubmit={(e) => createCustomer(e)}>
									<div>
										<div className="row">
											<div className="col-md-6">
												<Input
													label="COMPANY NAME"
													classLabel="h5"
													classInput="form-control"
													val={companyName}
													setVal={setCompanyName}
												/>
											</div>
											<div className="col-md-6">
												<div className="mt-4 mt-md-5">
													<input
														className="ml-2"
														type="radio"
														name="options"
														id="option3"
														onClick={() => setEnterprise(true)}
													/>
													<label htmlFor="option3" className="">
														<p className="ml-4 mt-2 radio">
															Enterprise Customer
														</p>
													</label>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-md-6">
												<Input
													val={firstName}
													setVal={setFirstName}
													label="FIRST NAME"
													classLabel="h5"
													classInput="form-control"
													validation="first_name"
													ref={firstNameRef}
												/>
											</div>
											<div className="col-md-6">
												<Input
													val={lastName}
													setVal={setLastName}
													label="LAST NAME"
													classLabel="h5"
													classInput="form-control"
													validation="last_name"
													ref={lastNameRef}
												/>
											</div>
										</div>
										<div className="row otmb-2">
											<div className="col-12 col-md-6">
												<Input
													label="EMAIL ADDRESS"
													classLabel="h5"
													classInput="form-control"
													validation="email"
													val={email}
													setVal={setEmail}
													ref={emailRef}
												/>
											</div>
											<div className="col-6 col-md-6 col-sm-5">
												<SelectDate
													val={
														birthDate
															? moment(birthDate).toDate()
															: moment().toDate()
													}
													classLabel="h5"
													setVal={setBirthDate}
													label="DATE OF BIRTH"
													validation="birthDate"
													ref={birthDateRef}
													maxDate={moment().subtract(25, "years").toDate()}
												/>
											</div>
										</div>
										<div className="row">
											<div className="col-md-6">
												<Input
													val={street}
													setVal={setStreet}
													label="STREET ADDRESS 1"
													classLabel="h5"
													classInput="form-control mb-md-3"
													validation="street"
													ref={streetRef}
												/>
											</div>
											<div className="col-md-6 ">
												<Input
													label="STREET ADDRESS 2"
													classLabel="h5"
													classInput="form-control mb-md-3"
													val={secondStreet}
													setVal={setSecondStreet}
												/>
											</div>
											<div className="col-md-6">
												<Input
													val={city}
													setVal={setCity}
													label="CITY"
													classLabel="h5"
													classInput="form-control"
													validation="city"
													ref={cityRef}
												/>
											</div>
											<div className="col mx-auto nopadding d-flex">
												<div className="col-md-6">
													<Select
														val={state}
														setVal={setState}
														label="STATE"
														options={usStateOptions}
														classLabel="h5"
														classSelect="form-control"
														validation="state"
														ref={stateRef}
													/>
												</div>
												<div className="col-md-6">
													<Input
														val={zipCode}
														setVal={setZipCode}
														label="ZIP CODE"
														classLabel="h5"
														classInput="form-control"
														validation="zipCode"
														ref={zipCodeRef}
													/>
												</div>
											</div>
										</div>

										<div className="row">
											<div className="d-md-flex justify-content-md-end otmb-3">
												<div className="otmt-2">
													<button
														type="submit"
														className="col-12 btn btn2 btn-lg"
													>
														START QUOTE
													</button>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default withRouter(PickCustomer);
